import { render, staticRenderFns } from "./PrevilageTable_mobile.vue?vue&type=template&id=37aa1a98&scoped=true"
import script from "./PrevilageTable_mobile.vue?vue&type=script&lang=js"
export * from "./PrevilageTable_mobile.vue?vue&type=script&lang=js"
import style0 from "./PrevilageTable_mobile.vue?vue&type=style&index=0&id=37aa1a98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aa1a98",
  null
  
)

export default component.exports